// extracted by mini-css-extract-plugin
export default {"nort-wrapper":"KitMonAn2_nort-wrapper__DnsXn"};